'use client'

import { useRef, useState } from 'react'
import cx from 'classnames'
import { useSession } from 'next-auth/react'

import { LightbulbLoading } from '@app/components/LightbulbLoading'

import { useEmbedDashboard } from './useEmbedDashboard'
import { useGetEmbedUrl } from './useGetEmbedUrl'

export function SalesOverviewDashboard() {
  const { data: session } = useSession()
  const containerRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true)
  const url = useGetEmbedUrl(session.accessToken)

  useEmbedDashboard({
    url,
    containerRef,
    setIsLoading,
  })

  return (
    <>
      {isLoading && <LightbulbLoading />}

      <div className={cx('h-full', isLoading ? 'opacity-0' : 'opacity-100', 'transition-opacity', 'duration-300')} ref={containerRef}></div>
    </>
  )
}
